import { render, staticRenderFns } from "./DriverConnectView.vue?vue&type=template&id=2a36c09d"
import script from "./DriverConnectView.vue?vue&type=script&lang=ts"
export * from "./DriverConnectView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports